export default __webpack_public_path__ + "static/logo-308c8a24062b34145dec547364a3be47.jpg";